<template>
  <div id="main-box" class="main-box" v-if="load_flg == true">
    <div class="sch-header">
      <div class="date-wrapper">
        <p class="prev" @click="date_chg(-1)"><span>＜前月</span></p>
        <p class="month">{{ disp_date.getFullYear() }}年 {{ disp_month }}月</p>
        <p class="next" @click="date_chg(1)">
          <span v-if="next_flg == true">次月＞</span>
        </p>
      </div>
    </div>
    <div class="sch-body">
      <div class="week">
        <p
          class="week-t"
          :class="week_class(index3)"
          v-for="(item, index3) in 7"
          :key="index3"
        >
          {{ week_text(index3) }}
        </p>
      </div>
      <div class="sch-y" v-for="(item, index) in 6" :key="index">
        <div
          class="sch-x"
          :class="[day_sb[index * 7 + index2], day[index * 7 + index2].sub]"
          v-for="(item, index2) in 7"
          :key="index2"
        >
          <p class="day">
            <span class="day-t">{{ day[index * 7 + index2].day }}</span>
            <span class="week-ts" :class="week_class(index2)"
              >({{ week_text(index2) }})</span
            >
          </p>
          <a
            class="sch-item"
            target="_blank"
            v-for="(sch_item, sch_indx) in sch[day[index * 7 + index2].date_s]"
            :key="sch_indx"
            :href="sch_item.url"
            :class="[`reservable-${sch_item.reservable_flag}`, `${sch_item.url ? 'link' : ''}`]"
            :title="sch_item.content.replace(/\n/g, '<br>')"
          >
            <p
              class="sch-item-date"
              v-html="timeDisp(sch_item.start_time, sch_item.end_time)"
            />
            <p
              class="sch-item-content"
              v-html="sch_item.content.replace(/\n/g, '<br>')"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  // ===========================================================================
  // components
  // ===========================================================================
  components: {},
  // ===========================================================================
  // data
  // ===========================================================================
  data() {
    return {
      next_flg: true,
      prev_flg: false,
      disp_date: new Date(),
      disp_month: new Date().getMonth() + 1,
      day: [],
      day_sb: [],
      holidays: {},
      sch: {},
      week_t: ["日", "月", "火", "水", "木", "金", "土"],
      load_flg: false
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  updated() {
    if (window.parent) {
      if (this.$DF.POST_URL != "") {
        window.parent.postMessage(
          document.body.scrollHeight,
          this.$DF.POST_URL
        );
      }
    }
  },
  computed: {},
  // ===========================================================================
  // created
  // ===========================================================================
  created() {},
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted() {
    let ld = new this.$loader(this);
    ld._data_set({});
    ld._post_cb_f = this.holiday_get_cb;
    ld._load_start("/manage/holiday_get.php");
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed() {},
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    date_chg(a) {
      const today = new Date();
      const m = this.disp_date.getMonth() + a;
      this.disp_date.setDate(1);
      this.disp_date.setMonth(m);
      this.disp_month = this.disp_date.getMonth() + 1;
      this.set_start(this.disp_date);

      const now_m = today.getMonth() + 1;
      if (now_m !== this.disp_month) {
        this.prev_flg = true;
      } else {
        this.prev_flg = false;
      }

      this.next_flg = true;
      //if (now_m > this.disp_month) {
      //  if ((now_m - this.disp_month) === 10) {
      //    this.next_flg = false;
      //  }
      //} else {
      //  if ((this.disp_month - now_m) === 2) {
      //    this.next_flg = false;
      //  }
      //}
      if (today < this.disp_date) {
        if (now_m > this.disp_month) {
          if (now_m - this.disp_month === 10) {
            this.next_flg = false;
          }
        }
      }

      this.sch_get();
    },
    set_start(date) {
      date.setDate(1);
      const start = date.getDay();
      date.setMonth(date.getMonth() + 1);
      date.setDate(0);
      const end = date.getDate();
      date.setDate(1);

      let d = 0;
      for (let i = 0; i < 42; i++) {
        d = i + 1 - start;
        this.day[i] = {};
        if (d <= 0) {
          date.setDate(d);

          this.day[i].day = date.getDate();
          this.day[i].sub = "sub-day";
          this.day[i].date_s = this.$lib._date_text_get(date);

          date.setDate(1);
          date.setMonth(date.getMonth() + 1);
        } else if (d > end) {
          date.setDate(d);

          this.day[i].day = d - end;
          this.day[i].sub = "sub-day";
          this.day[i].date_s = this.$lib._date_text_get(date);

          date.setDate(1);
          date.setMonth(date.getMonth() - 1);
        } else {
          date.setDate(d);

          this.day[i].day = d;
          this.day[i].sub = "";
          this.day[i].date_s = this.$lib._date_text_get(date);
          if (date.getDay() === 0) {
            this.day[i].sub = "sun";
          } else if (date.getDay() === 6) {
            this.day[i].sub = "sat";
          }
          if (this.holidays[this.day[i].date_s]) {
            this.day[i].sub = "sun";
          }
        }
      }
      this.day_sb = [];
      const now = new Date();
      if (now.getMonth() === date.getMonth()) {
        for (let i = 0; i < 42; i++) {
          if (this.day[i].date_s === this.$lib._date_text_get(now)) {
            this.day_sb[i] = "today";
            break;
          }
          this.day_sb[i] = "sub-day-box";
        }
      }
    },
    week_text(a) {
      return this.week_t[a];
    },
    week_class(a) {
      if (a === 0) {
        return "sun";
      } else if (a === 6) {
        return "sat";
      }
    },
    holiday_get_cb(data) {
      if (data.res === 1) {
        const hol = data.data.holidays;
        const num = hol.length;
        const list = {};
        for (let i = 0; i < num; i++) {
          list[hol[i].date] = hol[i].name;
        }
        this.holidays = list;

        this.set_start(new Date());

        this.load_flg = true;

        this.sch_get();
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    },
    timeDisp(start_time, end_time) {
      let str = "未定";
      if (start_time || end_time)
        str = `${start_time ? start_time : ""} 〜 ${end_time ? end_time : ""}`;
      return str;
    },
    sch_get() {
      let ld = new this.$loader(this);
      const m = this.$lib._date_text_get(this.disp_date).substr(0, 6);
      ld._data_set({ month: m });
      ld._post_cb_f = this.month_schedule_get_cb;
      ld._load_start("/user/month_schedule_get.php");
    },
    month_schedule_get_cb(data) {
      if (data.res === 1) {
        const sch = data.data.schedules;
        let num = sch.length;
        const list = {};
        for (let i = 0; i < num; i++) {
          if (
            Object.prototype.toString.call(list[sch[i].date]) !==
            "[object Array]"
          )
            list[sch[i].date] = [];
          list[sch[i].date].push(sch[i]);
        }

        this.sch = list;
      } else {
        this.$alert("alert", `エラーコード：${data.res}`);
      }
    },
    sch_reservable(type, a) {
      const d = this.day[a].date_s;
      if (this.sch[d]) {
        if (type === "reserve") {
          if (this.sch[d].reservable_flag === 1) {
            return "";
          } else if (this.sch[d].reservable_flag === 2) {
            return "移動販売";
          } else if (this.sch[d].reservable_flag === 3) {
            return "直売所";
          } else if (this.sch[d].reservable_flag === 0) {
            return "イベント";
          }
          return "";
        } else {
          return this.sch[d].content;
        }
      } else {
        if (type === "reserve") {
          return "";
        }
      }
    },
    sch_reservable_css(type, a) {
      const d = this.day[a].date_s;
      if (this.sch[d]) {
        if (type === "reserve") {
          if (this.sch[d].reservable_flag === 1) {
            return "sch-car";
          } else if (this.sch[d].reservable_flag === 2) {
            return "sch-shop";
          } else if (this.sch[d].reservable_flag === 3) {
            return "sch-event";
          }
        } else {
          return this.sch[d].content;
        }
      } else {
        if (type === "reserve") {
          return "sch-none";
        }
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {}
};
</script>

<style lang="scss">
.main-box {
  // width: 100%;
  width: 1280px;
  height: auto;
  text-align: left;
  .sch-header {
    background: url("../assets/header_bg.svg") center top no-repeat;
    // width: 100%;
    // height: 31.25vw;
    width: 1280px;
    height: 400px;

    .date-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      // padding: 11vw 0;
      padding: 140px 0 0;
      width: 490px;
    }
  }

  .next,
  .prev {
    background: #fef49e;
    width: 88px;
    font-size: 16px;
    font-weight: bold;
    line-height: 64px;
    text-align: center;
    color: #df274c;
    border-radius: 4px;
    cursor: pointer;
  }

  .month {
    background: url("../assets/date_bg.svg") center center no-repeat;
    width: 258px;
    height: 64px;
    font-size: 32px;
    line-height: 64px;
    font-weight: bold;
    color: #fff;
    text-align: center;
  }
  .sch-body {
    background: #faebeb;
    position: relative;
    border-top: #df274c 3px solid;
    margin-top: -68px;
    padding: 24px 32px;

    &:before {
      content: " ";
      display: block;
      position: absolute;
      top: -20px;
      left: calc(50% - 20px);
      width: 40px;
      height: 40px;
      background: url("../assets/calendar_ribbon.svg") center center no-repeat;
    }
  }
  .sch-y {
    display: flex;
    margin-top: 24px;
    justify-content: space-between;
  }
  .sch-x {
    background: #fff;
    min-height: 160px;
    padding-bottom: 8px;
    width: 160px;
    border-radius: 8px;

    &.sun {
      color: #e30400;
    }

    &.sat {
      color: #0027b1;
    }
  }
  .week {
    display: flex;
  }
  .week-t {
    flex: 1;
    background: url("../assets/leaf.svg") center top no-repeat;
    height: 56px;
    box-sizing: border-box;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    line-height: 56px;
    color: #ffffff;

    &.sun {
      background: url("../assets/leaf_sun.svg") center top no-repeat;
    }

    &.sat {
      background: url("../assets/leaf_sat.svg") center top no-repeat;
    }
  }
  .day {
    background: url("../assets/dot_line.svg") -4px bottom repeat-x;
    background-size: 16px 4px;
    text-align: left;
    font-size: 24px;
    line-height: 44px;
    font-weight: bold;
    padding: 0 12px;
  }
  .sub-day {
    background: #fde1e1;

    .day-t {
      color: #929292;
    }
  }
  .today {
    background: #fef6b1;

    border: #e4cd03 2px solid;
  }
  .sub-day-box {
    background: #fde1e1;

    .day .day-t {
      color: #929292;
    }
  }

  .sch-item {
    display: block;
    text-align: left;
    text-decoration: none;
    margin: 8px 8px 0;
    padding: 0px 4px 4px;
    border-radius: 8px;
    word-break: break-all;
    pointer-events: none;

    &.link {
      cursor: pointer;
      pointer-events: auto;
    }
  }

  .sch-item-date {
    &:before {
      content: " ";
      position: relative;
      top: 4px;
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
    }
  }

  .sch-item-content {
    font-weight: bold;
  }

  .reservable-1 {
    color: #945b0d;
    background: #fac479;

    .sch-item-date:before {
      background: url("../assets/sch_car.svg") top center no-repeat;
    }
  }

  .reservable-2 {
    color: #1d3031;
    background: #aedddf;
    .sch-item-date:before {
      background: url("../assets/sch_shop.svg") top center no-repeat;
    }
  }

  .reservable-3 {
    color: #c5062c;
    background: #f4c4ce;
    .sch-item-date:before {
      background: url("../assets/sch_event.svg") top center no-repeat;
    }
  }

  .week-ts {
    display: none;
  }
}
@media (max-width: 767px) {
  .main-box {
    width: 100%;

    .sch-header {
      background: url("../assets/sp/header_bg.svg") center top no-repeat;
      background-size: contain;
      width: 100%;
      height: 57.5vw;

      .date-wrapper {
        max-width: 75vw;
        width: 90%;
        padding: 21.2vw 0 0;

        .month {
          width: 40.31vw;
          height: 9.99vw;
          font-size: 4.99vw;
          line-height: 9.99vw;
        }

        .prev,
        .next {
          width: 13.75vw;
          line-height: 10vw;
          font-size: 3vw;
        }
      }
    }
    .sch-body {
      margin-top: -5vw;
      padding: 24px 24px 8px;
    }
    .sch-y {
      display: block;
      margin-top: 0;
    }
    .sch-x {
      width: 100%;
      height: auto;
      min-height: 88px;
      margin-bottom: 16px;

      .day {
        text-align: center;
      }
    }

    .sch-content {
      white-space: pre-wrap;
      overflow-y: none;
      height: auto;
    }
    .week-ts {
      display: inline-block;
    }
    .week {
      display: none;
    }
    .sub-day {
      display: none;
    }
  }
}
</style>
